export default __webpack_public_path__ + "static/media/Banner.c0040bda.svg";